import { jsx as d } from "react/jsx-runtime";
import { marked as a } from "marked";
import { HTMLRenderer as p } from "../HTMLRenderer/index.js";
const k = ({
  children: r,
  override: e,
  keepOriginalAnchors: o,
  allowedTags: t = [],
  overrides: m
}) => {
  const n = a(r || "", {
    gfm: !0,
    breaks: !0
  });
  return /* @__PURE__ */ d(
    p,
    {
      override: e,
      keepOriginalAnchors: o,
      allowedTags: t,
      overrides: m,
      children: n
    }
  );
};
export {
  k as Markdown
};
